import { Grid, useTheme } from '@mui/material'
import { OTPInput, OTPInputProps } from 'input-otp'
import { FC } from 'react'
import { themeMeta } from '../theme/meta'

const OtpInput: FC<OtpInputProps> = ({ ...passingProps }) => {
  const theme = useTheme()

  return (
    <OTPInput
      maxLength={6}
      pattern="^\d+$"
      required
      autoFocus
      render={({ slots }) => (
        <Grid container spacing={1.5}>
          {slots.map((slot, index) => (
            <Grid
              key={index}
              size={2}
              container
              justifyContent="center"
              alignItems="center"
              maxWidth={72}
              height={74}
              fontWeight={600}
              fontSize={36}
              borderRadius={theme.spacing(1)}
              {...(slot.isActive
                ? { sx: { outline: 3, outlineColor: 'currentColor' } }
                : {
                    bgcolor: themeMeta.colors.monochrome.input,
                  })}
            >
              {slot.char}
            </Grid>
          ))}
        </Grid>
      )}
      {...passingProps}
    />
  )
}

type OtpInputProps = Pick<OTPInputProps, 'name'> & {}

export { OtpInput }
export type { OtpInputProps }
